// import QRCode from "qrcode"
import { validate } from "../../utils/validate"
import { QRCode } from "./qrcode"
import { throwErrorMsg } from "../../utils/throwErrorMsg"

export const converter = {
  async qrCode(str = "", options) {
    const {
      codeSize = 200,
      icon,
      imageScale = 20,
      errorLevel = "Q",
      backgroundColor = "white",
      codeColor = "black",
    } = options || {}

    const colorToHexProxy = {
      "white": '#FFF',
      "black": '#000',
    }

    let canvas: HTMLCanvasElement | null = null
    let ctx: CanvasRenderingContext2D | null = null

    try {
      if (str == "" || typeof str !== "string")
        throw Error("Parameter must be of string type and cannot be empty.")
      // 判断二维码宽高
      if (codeSize < 0 || codeSize > 2000) {
        throw Error(
          "The QR code size cannot exceed 2000 and cannot be less than 0"
        )
      }
      if (imageScale < 0 || imageScale > 50) {
        throw Error(
          `The image ratio cannot exceed 50% and cannot be less than 0%. imageScale:${imageScale}`
        )
      }

      // 创建画布
      canvas = document.createElement('canvas')
      ctx = canvas.getContext('2d')
      if (!ctx) {
        throw new Error('Failed to get canvas context')
      }

      canvas.width = codeSize
      canvas.height = codeSize

      // 设置背景色
      ctx.fillStyle = colorToHexProxy[backgroundColor]
      ctx.fillRect(0, 0, codeSize, codeSize)

      // 生成二维码
      await (QRCode as any)?.toCanvas?.(canvas, str, {
        width: codeSize,
        errorCorrectionLevel: errorLevel,
        margin: 2,
        color: {
          dark: colorToHexProxy[codeColor],
          light: colorToHexProxy[backgroundColor]
        }
      })

      if (!icon) return canvas.toDataURL('image/png')

      // 加载并绘制图标
      const iconImg = new Image()
      iconImg.crossOrigin = 'anonymous'
      await new Promise((resolve, reject) => {
        iconImg.onload = resolve
        iconImg.onerror = reject
        iconImg.src = icon
      })

      // 计算图标尺寸和位置
      const iconSize = (codeSize * imageScale) / 100
      const iconX = (codeSize - iconSize) / 2
      const iconY = (codeSize - iconSize) / 2

      // 绘制图标
      ctx.drawImage(iconImg, iconX, iconY, iconSize, iconSize)

      return canvas.toDataURL('image/png')
    } catch (e) {
      throw Error(e)
    } finally {
      // 清理资源
      if (canvas) {
        canvas.width = 0
        canvas.height = 0
        canvas = null
      }
      ctx = null
    }
  },
  printPicture(schema: any) {
    throwErrorMsg("converter.printPicture")
  },
  dataToPicture(schema) {
    if (typeof schema !== "string" || !schema?.length) {
      throw Error("Parameter must be of string type and cannot be empty.")
    }
    throwErrorMsg("converter.dataToPicture")
  },
  onlinePrint({ url, type }) {
    validate.String(url, "url")
    validate.Enum(type, "type", ["jpg", "png", "pdf"])
    throwErrorMsg("converter.onlinePrint")
  },
  dataToBase64(schema) {
    if (typeof schema !== "string" || !schema?.length) {
      throw Error("Parameter must be of string type and cannot be empty.")
    }
    throwErrorMsg("converter.dataToBase64")
  },
  dataToBase64s(schema) {
    throwErrorMsg("converter.dataToBase64s")
  }
} as ConverterDSL
